// === DÉTECTION FIRST-LAUNCH-APRÈS-UPDATE ===
// Indépendant du tracking version-mismatch des sauvegardes (deadtide_meta).
// Logique : on stocke la dernière version vue par le joueur dans
// `deadtide_last_seen_version`. Si elle diffère de GAME_VERSION → on doit
// proposer la popup "Quoi de neuf". Premier lancement absolu (pas de clef) =
// pas de popup (le joueur n'a rien à découvrir, il démarre à zéro).

import { GAME_VERSION } from './MetaManager';

const STORAGE_KEY = 'deadtide_last_seen_version';

/**
 * Retourne true si le joueur a déjà lancé le jeu auparavant ET que la version
 * a changé depuis. Premier lancement absolu = false (rien à montrer).
 */
export function shouldShowPatchNotesPopup(): boolean {
  try {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) return false;          // jamais lancé → pas de popup
    return seen !== GAME_VERSION;     // upgrade détecté
  } catch {
    return false;
  }
}

/**
 * Marque la version actuelle comme vue. À appeler quand le joueur :
 * - ouvre PatchNotesScene
 * - ferme la popup "Quoi de neuf" (les deux actions valent acquittement)
 * - lance le jeu pour la 1ère fois (pour ne pas spammer la popup au 2ème lancement)
 */
export function markPatchNotesAsSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, GAME_VERSION);
  } catch {
    /* localStorage indisponible — silencieux */
  }
}

/**
 * Ré-arme la popup en supprimant la clef. Utile pour le mode Dev.
 */
export function resetPatchNotesSeen(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* */
  }
}

/** Retourne la dernière version vue par le joueur, ou null si jamais. */
export function getLastSeenVersion(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}
